/* eslint-disable global-require */
import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import { asyncComponent } from 'react-async-component';

import { defaultLanguage } from '../Intl/setup';
import { getPreferedLanguage } from './modules/Intl/IntlActions';

import authorization from './components/Auth/AuthorizationComponent';

import LocaleInitiator from './modules/Intl/components/init/LocaleInitiator';
import Loader from './components/Loader/Loader';

// Layout
import App from './modules/App/App';

// Generic pages
import ErrorPage from './modules/App/pages/error/ErrorPage';

// Import of async pages with need of async data load
// import ProductOrCmsPageAsync from './modules/App/pages/async/ProductOrCmsPageAsync';
import CmsPageAsync from './modules/Cms/pages/async/CmsPageAsync';


/* Workaround for async react routes to work with react-hot-reloader till
  https://github.com/reactjs/react-router/issues/2182 and
  https://github.com/gaearon/react-hot-loader/issues/288 is fixed.
 */
if(process.env.NODE_ENV !== 'production') {
    // Require async routes only in development for react-hot-reloader to work.
    // require('./modules/App/pages/view/HomePage');

    require('./modules/User/pages/auth/UserRegisterPage');
    require('./modules/User/pages/auth/UserLoginPage');
    require('./modules/User/pages/view/UserProfilePage');
    require('./modules/User/pages/edit/UserEditPage');
    require('./modules/User/pages/list/UserListPage');

    require('./modules/Cms/pages/view/CmsPage');
    // require('./modules/Contact/pages/ContactPage/ContactPage');

    require('./modules/Config/pages/view/ConfigPage');

    require('./modules/Product/pages/view/ProductViewPage');
    require('./modules/Cart/pages/view/CartPage');
    require('./modules/Order/pages/list/OrderListPage');
}


// Role Filter
const adminAuth = authorization(['admin']);
const customerAuth = authorization(['customer']);
const loggedInAuth = authorization([]);


// Set permissions by page
// Config page
// const configPageAuth = admin(require('./modules/Config/pages/ConfigPage/ConfigPage').default);


const HomePage = asyncComponent({
    LoadingComponent: () => <Loader hideContent />,
    resolve: () => import('./modules/App/pages/view/HomePage'),
});
// const ProductOrCmsPage = asyncComponent({
//     LoadingComponent: () => <Loader hideContent />,
//     resolve: () => import('./modules/App/pages/view/ProductOrCmsPage'),
// });
const UserRegisterPage = asyncComponent({
    LoadingComponent: () => <Loader hideContent />,
    resolve: () => import('./modules/User/pages/auth/UserRegisterPage'),
});
const UserLoginPage = asyncComponent({
    LoadingComponent: () => <Loader hideContent />,
    resolve: () => import('./modules/User/pages/auth/UserLoginPage'),
});
const UserProfilePage = asyncComponent({
    LoadingComponent: () => <Loader hideContent />,
    resolve: () => import('./modules/User/pages/view/UserProfilePage'),
});
const AddressListPage = asyncComponent({
    LoadingComponent: () => <Loader hideContent />,
    resolve: () => import('./modules/Address/pages/list/AddressListPage'),
});
const AddressEditPage = asyncComponent({
    LoadingComponent: () => <Loader hideContent />,
    resolve: () => import('./modules/Address/pages/edit/AddressEditPage'),
});
const CartPage = asyncComponent({
    LoadingComponent: () => <Loader hideContent />,
    resolve: () => import('./modules/Cart/pages/view/CartPage'),
});
const OrderListPage = asyncComponent({
    LoadingComponent: () => <Loader hideContent />,
    resolve: () => import('./modules/Order/pages/list/OrderListPage'),
});
const OrderViewPage = asyncComponent({
    LoadingComponent: () => <Loader hideContent />,
    resolve: () => import('./modules/Order/pages/view/OrderViewPage'),
});
const OrderAddPage = asyncComponent({
    LoadingComponent: () => <Loader hideContent />,
    resolve: () => import('./modules/Order/pages/form/OrderAddPage'),
});


// Console components
const AdminDashboard = asyncComponent({
    LoadingComponent: () => <Loader hideContent />,
    resolve: () => import('./modules/User/pages/view/AdminDashboard'),
});
const UserListPage = asyncComponent({
    LoadingComponent: () => <Loader hideContent />,
    resolve: () => import('./modules/User/pages/list/UserListPage'),
});
const UserEditPage = asyncComponent({
    LoadingComponent: () => <Loader hideContent />,
    resolve: () => import('./modules/User/pages/edit/UserEditPage'),
});
const ProductListPage = asyncComponent({
    LoadingComponent: () => <Loader hideContent />,
resolve: () => import('./modules/Product/pages/list/ProductListPage'),
});
const ProductEditPage = asyncComponent({
    LoadingComponent: () => <Loader hideContent />,
    resolve: () => import('./modules/Product/pages/edit/ProductEditPage'),
});
const OrderListAdminPage = asyncComponent({
    LoadingComponent: () => <Loader hideContent />,
    resolve: () => import('./modules/Order/pages/list/OrderListAdminPage'),
});
const ReviewListAdminPage = asyncComponent({
    LoadingComponent: () => <Loader hideContent />,
    resolve: () => import('./modules/Review/pages/list/ReviewListAdminPage'),
});
const ReviewEditPage = asyncComponent({
    LoadingComponent: () => <Loader hideContent />,
    resolve: () => import('./modules/Review/pages/edit/ReviewEditPage'),
});
const VoucherListPage = asyncComponent({
    LoadingComponent: () => <Loader hideContent />,
    resolve: () => import('./modules/Voucher/pages/list/VoucherListPage'),
});
const VoucherEditPage = asyncComponent({
    LoadingComponent: () => <Loader hideContent />,
    resolve: () => import('./modules/Voucher/pages/edit/VoucherEditPage'),
});
const CmsListPage = asyncComponent({
    LoadingComponent: () => <Loader hideContent />,
    resolve: () => import('./modules/Cms/pages/list/CmsListPage'),
});
const CmsEditPage = asyncComponent({
    LoadingComponent: () => <Loader hideContent />,
    resolve: () => import('./modules/Cms/pages/edit/CmsEditPage'),
});
const ConfigPage = asyncComponent({
    LoadingComponent: () => <Loader hideContent />,
    resolve: () => import('./modules/Config/pages/view/ConfigPage'),
});

const baseRoute = '/:lang([a-z]{2})';

function getPath(path = '', isAdmin = false) {
    return `${baseRoute}${isAdmin ? '/console' : ''}${path}`;
}

export const routesData = [
        // User mgmt
        {
            path: getPath('', true),
            exact: true,
            component: AdminDashboard,
        },
        {
            path: getPath('/users', true),
            exact: true,
            component: UserListPage,
        },
        {
            path: getPath('/user/:id?', true),
            exact: true,
            component: UserEditPage,
        },
        {
            path: getPath('/orders/:status?', true),
            exact: true,
            component: OrderListAdminPage,
        },
        {
            path: getPath('/order', true),
            exact: true,
            component: OrderAddPage,
        },
        {
            path: getPath('/order/:id', true),
            exact: true,
            component: OrderViewPage,
        },
        {
            path: getPath('/reviews/:status?', true),
            exact: true,
            component: ReviewListAdminPage,
        },
        {
            path: getPath('/review/:id?', true),
            exact: true,
            component: ReviewEditPage,
        },
        {
            path: getPath('/products', true),
            exact: true,
            component: ProductListPage,
        },
        {
            path: getPath('/product/:id?', true),
            exact: true,
            component: ProductEditPage,
        },
        // Voucher mgmt
        {
            path: getPath('/vouchers', true),
            exact: true,
            component: VoucherListPage,
        },
        {
            path: getPath('/voucher/:id?', true),
            exact: true,
            component: VoucherEditPage,
        },
        // Order mgmt
        // Testimonial mgmt
        {
            path: getPath('/contents', true),
            exact: true,
            component: CmsListPage,
        },
        {
            path: getPath('/content/:id?', true),
            exact: true,
            component: CmsEditPage,
        },
        {
            path: getPath('/config', true),
            exact: true,
            component: ConfigPage,
        },

    ].map(adminRoute => ({ ...adminRoute, component: adminAuth(adminRoute.component) }))
    .concat(
        [
            {
                path: getPath(),
                exact: true,
                component: CmsPageAsync,
                // pagePath: './modules/App/pages/view/HomePage',
            },
            {
                path: '/',
                exact: true,
                redirect: baseRoute,
            },
            {
                path: getPath('/cart/:step?/:orderId?'),
                exact: true,
                component: CartPage,
            },
            {
                path: getPath('/orders/:code?'),
                exact: true,
                component: loggedInAuth(OrderListPage),
            },
            {
                path: getPath('/address/:id?'),
                exact: true,
                component: loggedInAuth(AddressEditPage),
            },
            {
                path: getPath('/addresses'),
                exact: true,
                component: loggedInAuth(AddressListPage),
            },
            {
                path: getPath('/user/register'),
                exact: true,
                component: UserRegisterPage,
            },
            {
                path: getPath('/user/login'),
                exact: true,
                component: UserLoginPage,
            },
            {
                path: getPath('/user/resetpassword'),
                exact: true,
                component: UserLoginPage,
            },
            {
                path: getPath('/user/profile'),
                exact: true,
                component: loggedInAuth(UserProfilePage),
            },
            // Product
            // CMS
            {
                path: getPath('/:slug+'),
                component: CmsPageAsync,
            },
        ],
    );

export const layoutComponent = App;

// react-router setup with code-splitting
function Routes({ dispatch, ssr }) {
    return (
        <App>
            <Route path={getPath()}>
                {({ match, location }) => {
                    /**
                    * Get current language
                    * Set default locale to en if base path is used without a language
                    */
                    const params = match ? match.params : {};
                    let { lang } = params;

                    if(!ssr && !lang) {
                        lang = getPreferedLanguage() || defaultLanguage;
                    }

                    /**
                    * If language is not in route path, redirect to language root
                    */
                    const { pathname } = location;
                    if(!ssr && (!lang || !pathname.includes(`/${lang}`))) {
                        console.log('Redirect to localized url', pathname, lang);
                        return <Redirect to={`/${lang}${pathname}`} />;
                    }

                    // console.log('Lang from route', lang);
                    /**
                    * Return Intl provider with default language set
                    */
                    return (
                        <LocaleInitiator locale={lang}>
                            <Switch>
                                {
                                    routesData.map((route, index) => {
                                        if(route.redirect) {
                                            return <Redirect key={index} status={301} exact={route.exact} from={route.path} to={route.redirect} />;
                                        }
                                        // if(route.pagePath) {
                                        //     return (
                                        //         <Route key={index} {...route} render={props => <AsyncComponent path={route.pagePath} {...props} />} />
                                        //     );
                                        // }
                                        return <Route key={index} {...route} />;
                                    })
                                }
                                <Route path="*" component={ErrorPage} />;
                            </Switch>
                        </LocaleInitiator>
                        );
                    }}
            </Route>
        </App>

    );
}
Routes.defaultProps = {
    ssr: false,
};
Routes.propTypes = {
    dispatch: PropTypes.func.isRequired,
    ssr: PropTypes.bool,
 };

export default connect()(Routes);
